<template>
  <div class="input-field">
    <input :disabled="flagDisabled" class="input" type="tel" :value="initialValue" :id="id" ref="input"
           :placeholder="placeholder"/>
    <label :for="id"><span>{{label}}</span></label>
  </div>
</template>

<script>
  export default {
    props: ['value', 'id', 'label', 'placeholder', 'decimals', 'flagDisabled'],
    watch: {
      value (newValue) {
        this.reload(newValue, true)
      },
    },
    data () {
      return {
        initialValue: '',
      }
    },
    created () {
      this.reload(this.value, true)
    },
    mounted () {
      let that = this
      let input = $(this.$refs.input)

      input.on('keyup', function (e) {
        let value = e.target.value

        value = value.replace(/\./g, '')
        value = value.replace(',', '.')

        if (that.decimals) {
          if (value.length <= 3) {
            let pad = '000'
            value = pad.substring(0, pad.length - value.length) + value
            if (value[0] == 0) {
              value = value[0] + '.' + value[1] + value[2]
            }
          }
        }
        value = parseFloat(value)
        if (that.decimals) {
          value = value.toFixed(2)
        }
        that.$emit('input', value)
      })
      let mask = this.decimals === true ? '#.##0,00' : '#.##0'

      input.mask(mask, { reverse: true }) //, thousands: '', decimal:',', precision: 2
    },
    methods: {
      limparInput () {
        let maskMoney = $(this.$refs.input)

        maskMoney.val('')
        this.$emit('input', '')

        Materialize.updateTextFields()
      },
      reload (value, initial) {
        let maskMoney = $(this.$refs.input)

        if (value) {
          if (this.decimal) {
            value = value.toFixed(2)
          }

          value = value.toString()

          if (this.decimals === true) {
            value = value.replace('.', ',')
          }

          value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        }

        maskMoney.val(value)
        if (initial) {
          this.initialValue = value
        }
      },
    },
  }
</script>

<style scoped>
  button:hover {
    display: block;
  }

  input:focus + button {
    display: block;
  }

  button {
    display: none;
    position: absolute;
    right: 0;
    bottom: -20px;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/MaskMoney.vue